import type {FormEditor} from "@t/fd/editor/FormEditor.ts";

export interface RingSelectLabels {
	/** předem, před událostí, před krokem (defaults to the res key: ring.before) */
	before?: string;
	/** v čase, v čase události, v čase odhadu ukončení, ... (defaults to the res key: ring.exact) */
	at?: string;
	/** poté, po skončení události, po termínu, ... (defaults to the res key: ring.after) */
	after?: string;
}

export interface RingSelect extends FormEditor {
	type: "ring-select";
	/** List of pre-defined typical values */
	list: string;
	labels?: RingSelectLabels;
}

/** Special values of ring-before, see Task.java */
export const DONT_RING:number = 0;
export const RING_AT_START:number = 1;
